import actionTypes from './actions/actionTypes'

const {
  REQUEST_DETAILS,
  RECEIVE_DETAILS,
  REQUEST_REGISTRATON,
  RECEIVE_REGISTRATON
} = actionTypes

const registrationReducer = (
  state = {
    isFetchingConferenceDetails: false,
    isRequestingRegisteration: false,
    conferenceDetails: {}
  },
  action
) => {
  switch (action.type) {
    case REQUEST_DETAILS:
      return Object.assign({}, state, {
        isFetchingConferenceDetails: true
      })
    case RECEIVE_DETAILS:
      return Object.assign({}, state, {
        isFetchingConferenceDetails: false,
        conferenceDetails: action.conferenceDetails
      })
    case REQUEST_REGISTRATON:
      return Object.assign({}, state, {
        isRequestingRegisteration: true
      })
    case RECEIVE_REGISTRATON:
      return Object.assign({}, state, {
        isRequestingRegisteration: false
      })
    default:
      return state
  }
}

export default registrationReducer



// WEBPACK FOOTER //
// ./src/routes/Registration/reducer.js